import declare from "dojo/_base/declare";
import _TemplatedMixin from "dijit/_TemplatedMixin";
import _WidgetBase from "dijit/_WidgetBase";
import html from "csi/html";

const templateString = `<div
	><div class="\$\{baseClass\}-top"
	></div
	><div class="\$\{baseClass\}-middle"
		><div class="\$\{baseClass\}-content"
			><div class="\$\{baseClass\}-spinner" data-dojo-attach-point="spinnerNode"
				><svg viewBox="22 22 44 44"
					><circle cx="44" cy="44" r="20.2" fill="none" stroke-width="3.6"
				/></svg
			></div
			><div class="\$\{baseClass\}-message" data-dojo-attach-point="messageNode"
			></div
		></div
		><div class="\$\{baseClass\}-go-to-dialog" data-dojo-attach-point="goToDialogNode"
			><a data-dojo-attach-event="click:_onClickGoToDialog">\$\{GoToDialog:_nls\}</a
		></div
	></div
	><div class="\$\{baseClass\}-hint" data-dojo-attach-point="hintNode"
		><label>\$\{Hint:_nls\}:</label
		><span data-dojo-attach-point="hintMessageNode"></span
	></div
></div>
`;

const ComboBoxPlaceholder = declare([_WidgetBase, _TemplatedMixin], {
	baseClass: "csi-combo-box-placeholder",
	templateString,

	// attach points
	goToDialogNode: null,
	hintNode: null,
	hintMessageNode: null,
	messageNode: null,
	spinnerNode: null,

	/** text to display for hint */
	hint: "",

	/** rich text message to display - if not given, then whole placeholder will be hidden */
	message: "",

	/** callback function for Go to Dialog; if not specified, then do not show action */
	onGoToDialog: null,

	/** indicate if searching */
	searching: false,

	/** set initial visibility */
	postCreate() {
		html.setVisible(this.goToDialogNode, !!this.onGoToDialog);
		this._updateHintVisibility();
		this.inherited(arguments);
	},

	/** click handler for Go to Dialog */
	_onClickGoToDialog() {
		this.onGoToDialog?.();
	},

	/** this is needed to satisfy Typescript - I guess "_set" is not part of the _WidgetBase typings */
	_set(attr: string, value: any) {
		this.inherited(arguments);
	},

	/** set hint message - if none, then hide hint entirely */
	_setHintAttr(value: string) {
		this._set("hint", value);
		html.setInnerText(this.hintMessageNode, value);
		this._updateHintVisibility();
	},

	/** set message - if none, then hide */
	_setMessageAttr(value: string) {
		this._set("message", value);
		html.richText(value, this.messageNode);
		html.setVisible(this.domNode, !!value);
	},

	/** set visibililty of spinner */
	_setSearchingAttr(value: boolean) {
		this._set("searching", value);
		this._updateHintVisibility();
		this.domNode.classList.toggle("searching", value);
	},

	/** set visibility of hint - do not show when searching */
	_updateHintVisibility() {
		const { hint, hintNode, searching } = this;
		html.setVisibility(hintNode, !!hint && !searching);
	},
});

export = ComboBoxPlaceholder;